import { render, staticRenderFns } from "./fanshui.vue?vue&type=template&id=7f175428&scoped=true"
import script from "./fanshui.vue?vue&type=script&lang=js"
export * from "./fanshui.vue?vue&type=script&lang=js"
import style0 from "./fanshui.vue?vue&type=style&index=0&id=7f175428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f175428",
  null
  
)

export default component.exports